import type { ApiKeyCreate } from '../../generated/api/types.gen.js';

/**
 * The create request the issue-key dialog sends. Runtime and deployment keys carry only their name, scope and
 * environment. A personal key adds the person and, only when set, its metadata: the grants it is narrowed to (none
 * ticked = the person's full permissions) and market data access (off unless ticked).
 */
export function issueApiKeyBody(values: ApiKeyCreate): ApiKeyCreate {
  if (values.scope !== 'user') {
    return { name: values.name, scope: values.scope, environmentSlug: values.environmentSlug };
  }
  const grants = values.metadata?.grants ?? [];
  const metadata = {
    ...(grants.length > 0 ? { grants } : {}),
    ...(values.metadata?.dataAccessEnabled === true ? { dataAccessEnabled: true } : {}),
  };
  return {
    name: values.name,
    scope: values.scope,
    environmentSlug: values.environmentSlug,
    ...(values.userId !== undefined ? { userId: values.userId } : {}),
    ...(Object.keys(metadata).length > 0 ? { metadata } : {}),
  };
}
